export class WebhookV1StandardPayloadPolicyAssignmentArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicyNotificationArguments",
            "baseName": "backupPolicyNotificationArguments",
            "type": "WebhookV1BackupPolicyNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadPolicyAssignmentArguments.attributeTypeMap;
    }
    constructor() {
    }
}
